import { render } from "./ficheViewer.vue?vue&type=template&id=6e5589c4&scoped=true"
import script from "./ficheViewer.vue?vue&type=script&lang=js"
export * from "./ficheViewer.vue?vue&type=script&lang=js"

import "./ficheViewer.vue?vue&type=style&index=0&id=6e5589c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5589c4"]])

export default __exports__